import { __read, __spreadArray } from "tslib";
import { every, get, round } from 'lodash-es';
import { NORMAL } from '../../constants/blendMode';
export function getOpacity(element) {
    var opacity = 1;
    var parent = element;
    while (parent) {
        opacity *= parent.itemProps.opacity;
        parent = parent.positionParent;
    }
    if (opacity < 1) {
        return round(opacity, 2);
    }
    return undefined;
}
export function getBlendMode(element) {
    var blendMode;
    var parent = element;
    while (parent) {
        (blendMode = parent.itemProps.blendMode);
        if (blendMode !== NORMAL) {
            return blendMode;
        }
        parent = parent.positionParent;
    }
    return blendMode;
}
export function hasNoShadow(element) {
    var shadowValues = __spreadArray(__spreadArray([], __read(get(element, 'shadowStyle.shadowOffset', [0, 0])), false), [
        get(element, 'shadowStyle.shadowBlur', 0),
    ], false);
    var hasNoShadowVals = every(shadowValues, function (v) { return v === 0; });
    return hasNoShadowVals;
}
